var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Notebook"},[_c('TextAreaInput',{attrs:{"value":_vm.note,"resizable":true,"placeholder":"Skriv anteckningar här..."},on:{"resize":_vm.resize,"resizedone":_vm.resizedone,"input":_vm.updateNotesDebounced}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }